import { render, staticRenderFns } from "./MailAssitant.vue?vue&type=template&id=5a9846be&scoped=true"
import script from "./MailAssitant.vue?vue&type=script&lang=js"
export * from "./MailAssitant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9846be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/print-suite/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a9846be')) {
      api.createRecord('5a9846be', component.options)
    } else {
      api.reload('5a9846be', component.options)
    }
    module.hot.accept("./MailAssitant.vue?vue&type=template&id=5a9846be&scoped=true", function () {
      api.rerender('5a9846be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/entries/MailAssitant.vue"
export default component.exports